<template>
    <div style="min-height: 550px">
        <div class="md-layout md-alignment-bottom-right">
            <div class="md-layout-item md-size-45">
                <vue-ctk-date-time-picker
                    :disabled="fetching"
                    :auto-close="false"
                    @validate="fetchData"
                    :label="$t('fecha')"
                    :only-date="true"
                    v-model="selectedDate"
                    formatted="YYYY-MM-DD"
                    format="YYYY-MM-DD"
                >
                </vue-ctk-date-time-picker>
            </div>
        </div>
        <div id="chart" style="overflow-x: auto; margin-top: 60px">
            <table
                id="firstTable"
                style="width: 100%; border-collapse: collapse"
            >
                <thead>
                    <tr></tr>
                </thead>
                <tbody>
                    <tr
                        style="
                            padding-bottom: 15px;
                            border-bottom: 5px solid white;
                        "
                        v-for="(row, index) in grafica"
                        :key="index"
                    >
                        <td style="height: 30px; width: 30px">
                            {{ row["date"] }}
                        </td>
                        <td
                            style="height: 30px"
                            :class="r.clase"
                            :data-fecha="r.x"
                            v-for="r in row['data']"
                            :key="r.id"
                        ></td>
                    </tr>

                    <!-- pinto el timeline -->
                </tbody>
                <tfoot>
                    <tr style="text-align: center">
                        <td style="height: 30px; width: 30px"></td>
                        <td style="text-align: left" colspan="12">00</td>
                        <td colspan="12">01</td>
                        <td colspan="12">02</td>
                        <td colspan="12">03</td>
                        <td colspan="12">04</td>
                        <td colspan="12">05</td>
                        <td colspan="12">06</td>
                        <td colspan="12">07</td>
                        <td colspan="12">08</td>
                        <td colspan="12">09</td>
                        <td colspan="12">10</td>
                        <td colspan="12">11</td>
                        <td colspan="12">12</td>
                        <td colspan="12">13</td>
                        <td colspan="12">14</td>
                        <td colspan="12">15</td>
                        <td colspan="12">16</td>
                        <td colspan="12">17</td>
                        <td colspan="12">18</td>
                        <td colspan="12">19</td>
                        <td colspan="12">20</td>
                        <td colspan="12">21</td>
                        <td colspan="12">22</td>
                        <td colspan="12">23</td>
                    </tr>
                </tfoot>
            </table>

            <!-- Leyenda-->
        </div>
        <div class="md-layout md-alignment-bottom-left">
            <div class="md-layout-item">
                <md-icon style="color: #9fa8da">lens</md-icon>
                {{ $t("dry") }}
                <span style="width: 20px; display: inline-block"></span>

                <md-icon style="color: #ffff00">lens</md-icon>
                {{ $t("level1") }}
                <span style="width: 20px; display: inline-block"></span>

                <md-icon style="color: #ffa500">lens</md-icon>
                {{ $t("level2") }}
                <span style="width: 20px; display: inline-block"></span>

                <md-icon style="color: #ff0000">lens</md-icon>
                {{ $t("level3") }}
                <span style="width: 20px; display: inline-block"></span>

                <md-icon style="color: rgb(217, 217, 217)">lens</md-icon>
                {{ $t("off") }}
                <span style="width: 20px; display: inline-block"></span>

                <md-icon style="color: rgb(166, 166, 166)">lens</md-icon>
                {{ $t("on_disconnected") }}
                <span style="width: 20px; display: inline-block"></span>

                <md-icon style="color: rgb(128, 128, 128)">lens</md-icon>
                {{ $t("out_of_range") }}
                <span style="width: 20px; display: inline-block"></span>
            </div>
        </div>
    </div>
</template>

<script>
let BACKEND_API = process.env.VUE_APP_BACKEND_API;
import { authHeader } from "../../helpers/auth-header";
import { handleResponse } from "../../helpers/handle-response";

export default {
    name: "week_chart_html",
    components: {},
    props: ["paciente"],
    mounted() {
        this.fetchData();
    },
    data() {
        return {
            selectedDate: this.$moment(new Date()).format("YYYY-MM-DD"),
            fetching: false,
            grafica: [],
        };
    },
    methods: {
        getClase(n) {
            let status = "";
            if (n === 0 || n === null) {
                status = "bg-disconnected";
            }
            if (n === 1 || n === 2) {
                status = "bg-dry";
            }
            if (n === 3) {
                status = "bg-level1";
            }
            if (n === 4) {
                status = "bg-level2";
            }
            if (n === 5) {
                status = "bg-level3";
            }
            if (n >= 6 && n < 50) {
                //Para fechas en el futuro
                status = "bg-off";
            }
            if (n === 50) {
                //SOFF
                status = "bg-off";
            }
            if (n === 60) {
                //NNET
                status = "bg-black";
            }
            return status;
        },
        fetchData() {
            let self = this;
            let date = this.$moment(self.selectedDate).format("YYYY-MM-DD");
            this.fetching = true;
            const requestOptions = {
                method: "GET",
                headers: authHeader(),
            };
            fetch(
                `${BACKEND_API}/api/pacientes/chart/` +
                    this.$props.paciente +
                    `/` +
                    date,
                requestOptions
            )
                .then(handleResponse)
                .then((response) => {
                    let chartSeries = [];
                    let loop = 0;
                    response.forEach(function (obj, idx) {
                        chartSeries[loop] = {
                            data: [],
                            date: obj["date"],
                        };
                        let loopIn = 0;
                        obj["data"]["series"].forEach(function (serie, idx2) {
                            chartSeries[loop]["data"][loopIn] = {
                                id: loop + "" + loopIn,
                                time: serie["x"],
                                date: obj["date"],
                                clase: self.getClase(serie["y"]),
                            };
                            loopIn = parseInt(loopIn) + 1;
                        });
                        loop = parseInt(loop) + 1;
                    });
                    this.fetching = false;
                    this.grafica = chartSeries;
                });
        },
    },
};
</script>

<style scoped>
.bg-off {
    background-color: rgb(217, 217, 217);
    height: 1px;
    width: 1px;
}

.bg-disconnected {
    background-color: rgb(166, 166, 166);
    height: 1px;
    width: 1px;
}

.bg-no-diaper {
    background-color: #9fa8da;
    height: 1px;
    width: 1px;
}

.bg-dry {
    background-color: #9fa8da;
    height: 1px;
    width: 1px;
}

.bg-level1 {
    background-color: #ffff00;
    height: 1px;
    width: 1px;
}

.bg-level2 {
    background-color: #ffa500;
    height: 1px;
    width: 1px;
}

.bg-level3 {
    background-color: #ff0000;
    height: 1px;
    width: 1px;
}

.bg-no-signal {
    background-color: #ff0000;
    height: 1px;
    width: 1px;
}

.bg-black {
    background-color: rgb(128, 128, 128);
    height: 1px;
    width: 1px;
}

.bg-green {
    background-color: green;
    height: 1px;
    width: 1px;
}

.apexcharts-heatmap-series {
    border: 3px solid white !important;
}

.pt-2 {
    margin-top: 20px;
}
</style>
